// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1793824354522
      var cssReload = require("/home/elopez/repos/FacturaIzzi/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  